/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../Constants", "../FluxCommon/ActionsHubManager", "../FluxCommon/Store", "../Pods/PodsActions", "./WorkloadsActions"], function (require, exports, Constants_1, ActionsHubManager_1, Store_1, PodsActions_1, WorkloadsActions_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var WorkloadsStore = /** @class */ (function (_super) {
        __extends(WorkloadsStore, _super);
        function WorkloadsStore() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._setDeploymentsList = function (deploymentsList) {
                _this._state.deploymentList = deploymentsList;
                var deploymentItems = deploymentsList ? deploymentsList.items || [] : [];
                for (var _i = 0, deploymentItems_1 = deploymentItems; _i < deploymentItems_1.length; _i++) {
                    var deployment = deploymentItems_1[_i];
                    if (deployment && deployment.metadata.namespace) {
                        _this._state.deploymentNamespace = deployment.metadata.namespace;
                        break;
                    }
                }
                _this.emit(Constants_1.WorkloadsEvents.DeploymentsFetchedEvent, _this);
                if (_this._state.deploymentList && _this._state.deploymentList.items && _this._state.deploymentList.items.length > 0) {
                    _this.emit(Constants_1.WorkloadsEvents.WorkloadsFoundEvent, _this);
                }
                else {
                    _this.emit(Constants_1.WorkloadsEvents.ZeroDeploymentsFoundEvent, _this);
                }
            };
            _this._setReplicaSetsList = function (replicaSetList) {
                _this._state.replicaSetList = replicaSetList;
                _this.emit(Constants_1.WorkloadsEvents.ReplicaSetsFetchedEvent, _this);
                if (_this._state.replicaSetList && _this._state.replicaSetList.items && _this._state.replicaSetList.items.length > 0) {
                    _this.emit(Constants_1.WorkloadsEvents.WorkloadsFoundEvent, _this);
                }
            };
            _this._setDaemonSetsList = function (daemonSetList) {
                _this._state.daemonSetList = daemonSetList;
                _this.emit(Constants_1.WorkloadsEvents.DaemonSetsFetchedEvent, _this);
                if (_this._state.daemonSetList && _this._state.daemonSetList.items && _this._state.daemonSetList.items.length > 0) {
                    _this.emit(Constants_1.WorkloadsEvents.WorkloadsFoundEvent, _this);
                }
            };
            _this._setStatefulsetsList = function (statefulSetList) {
                _this._state.statefulSetList = statefulSetList;
                _this.emit(Constants_1.WorkloadsEvents.StatefulSetsFetchedEvent, _this);
                if (_this._state.statefulSetList && _this._state.statefulSetList.items && _this._state.statefulSetList.items.length > 0) {
                    _this.emit(Constants_1.WorkloadsEvents.WorkloadsFoundEvent, _this);
                }
            };
            _this._setOrphanPodsList = function (payload) {
                var orphanPods = [];
                payload.podsList && payload.podsList.items && payload.podsList.items.forEach(function (pod) {
                    if (!pod.metadata.ownerReferences) {
                        orphanPods.push(pod);
                    }
                });
                _this._state.orphanPodsList = orphanPods;
                _this.emit(Constants_1.WorkloadsEvents.WorkloadPodsFetchedEvent, _this);
                if (_this._state.orphanPodsList && _this._state.orphanPodsList.length > 0) {
                    _this.emit(Constants_1.WorkloadsEvents.WorkloadsFoundEvent, _this);
                }
            };
            return _this;
        }
        WorkloadsStore.getKey = function () {
            return "workloads-store";
        };
        WorkloadsStore.prototype.initialize = function (instanceId) {
            _super.prototype.initialize.call(this, instanceId);
            this._state = { deploymentNamespace: "", deploymentList: undefined, replicaSetList: undefined, daemonSetList: undefined, statefulSetList: undefined, orphanPodsList: [] };
            this._workloadActions = ActionsHubManager_1.ActionsHubManager.GetActionsHub(WorkloadsActions_1.WorkloadsActions);
            this._podsActions = ActionsHubManager_1.ActionsHubManager.GetActionsHub(PodsActions_1.PodsActions);
            this._workloadActions.deploymentsFetched.addListener(this._setDeploymentsList);
            this._workloadActions.replicaSetsFetched.addListener(this._setReplicaSetsList);
            this._workloadActions.daemonSetsFetched.addListener(this._setDaemonSetsList);
            this._workloadActions.statefulSetsFetched.addListener(this._setStatefulsetsList);
            this._podsActions.podsFetched.addListener(this._setOrphanPodsList);
        };
        WorkloadsStore.prototype.disposeInternal = function () {
            this._workloadActions.deploymentsFetched.removeListener(this._setDeploymentsList);
            this._workloadActions.replicaSetsFetched.removeListener(this._setReplicaSetsList);
            this._workloadActions.daemonSetsFetched.removeListener(this._setDaemonSetsList);
            this._workloadActions.statefulSetsFetched.removeListener(this._setStatefulsetsList);
            this._podsActions.podsFetched.removeListener(this._setOrphanPodsList);
        };
        WorkloadsStore.prototype.getState = function () {
            return this._state;
        };
        WorkloadsStore.prototype.getWorkloadSize = function () {
            return (this._state.deploymentList ? (this._state.deploymentList.items || []).length : 0) +
                (this._state.replicaSetList ? (this._state.replicaSetList.items || []).length : 0) +
                (this._state.daemonSetList ? (this._state.daemonSetList.items || []).length : 0) +
                (this._state.statefulSetList ? (this._state.statefulSetList.items || []).length : 0) +
                (this._state.orphanPodsList ? (this._state.orphanPodsList || []).length : 0);
        };
        return WorkloadsStore;
    }(Store_1.StoreBase));
    exports.WorkloadsStore = WorkloadsStore;
});
